import type { StatusPillPaletteId } from 'ds';
import { WorkOrderStatus } from 'shared';

/** Work order status → palette + default label. Single source of truth (same pattern as supportTicketStatusConfig). */
export const WORK_ORDER_STATUS_CONFIG: Record<WorkOrderStatus, { paletteId: StatusPillPaletteId; label: string }> = {
  new: { paletteId: 'gold', label: 'Draft' },
  needs_approval: { paletteId: 'red-light', label: 'Needs Approval' },
  scheduling: { paletteId: 'blue-light', label: 'Scheduling' },
  scheduled: { paletteId: 'blue', label: 'Scheduled' },
  completed: { paletteId: 'green', label: 'Completed' },
  canceled: { paletteId: 'gray', label: 'Canceled' }
};

/** Returns palette + label for a work order status pill. Spread into StatusPill: getWorkOrderStatusPillProps(status, formattedDate). */
export function getWorkOrderStatusPillProps(
  status: WorkOrderStatus,
  formattedScheduledDate?: string | null
): { palette: StatusPillPaletteId; label: string } {
  const { paletteId, label: defaultLabel } = WORK_ORDER_STATUS_CONFIG[status];
  const label = status === 'scheduled' && formattedScheduledDate ? `Scheduled ${formattedScheduledDate}` : defaultLabel;
  return { palette: paletteId, label };
}
